import { PreviewItem } from "./preview-item";

export class Preview {
    content?: PreviewItem[];
    genus?: PreviewItem[];

    constructor(source?: any) {
        if (source) {
            this.content = source.content?.map((item: any) => new PreviewItem(item));
            this.genus = source.genus?.map((item: any) => new PreviewItem(item));
        }
    }
}
